<template>
  <div>
    <Nav isActive="Task"/>  
    <div class="pageWD mT20 shadowBox" v-if="!showtype">
       <div class="mainTop f18 c3" >考试结果.....</div> 
       <div class="c3 ksjg" v-if="pageData">
           <div class="f18 flex">{{pageData.info.exTitle}}</div>
           <div class="flex"><span class="f16 c9">提交时间：</span><span class="f16">{{$conFun.parseData(pageData.examanswer.AN_FinishTime)}}</span></div>
           <div class="flex">
              <div><span class="f16 c9">考试时长：</span><span class="f16">{{pageData.info.exExamTime}}分钟</span></div>
              <div><span class="f16 c9">得分：</span><span class="f16">{{pageData.examanswer.AN_Score}}分</span></div>
              <div><span class="f16 c9">答对：</span><span class="f16">{{pageData.examanswer.rightNum}}题</span></div>
           </div>
           <div class="flex" style="margin-bottom:0">
              <div><span class="f16 c9">作答时长：</span><span class="f16">{{zdsc}}</span></div>
              <div><span class="f16 c9">合格：</span><span class="f16">{{hg}}分</span></div>
              <div><span class="f16 c9">正确率：</span><span class="f16">{{percent_}}</span></div>
           </div>
       </div>
       <div class="ckjg"> <el-button type="primary" style="width:240px" @click="tapSee">查看结果</el-button></div>
    </div>
    <div class="pageWD mT20" v-if="showtype">
      <div>   
        <el-row :gutter="20">
          <el-col :span="6" >       
            <div class="shadowBox minHeight">
              <div class="mainTop f18 c3" >答题卡
            </div>
                <div class="cardItem">
                  <div class="st flex"><span class="f16 c3 s2">答对</span><span  class="f16 c3 s1">答错</span></div>
                  <div v-if="list_dx.length > 0">   
                    <div class="f16 c9 t">单选题</div>  
                    <div class="flex">                                                    
                      <div v-for="(item,index) in list_dx" :key="index" :class="[item.answer=='1'?'select':'']" class="item" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div> 
                    </div>                      
                  </div>
                  <div v-if="list_dd.length > 0">
                    <div class="f16 c9 t">多选题</div>
                    <div class="flex" >                
                        <div class="item" v-for="(item,index) in list_dd" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div>
                  <div v-if="list_pd.length > 0">
                    <div class="f16 c9 t">判断题</div>
                    <div class="flex" >                   
                          <div class="item" v-for="(item,index) in list_pd" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div>
                  <div v-if="list_tk.length > 0">
                    <div class="f16 c9 t">填空题</div>
                    <div class="flex">                    
                        <div class="item" v-for="(item,index) in list_tk" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div>
                  <div v-if="list_jd.length > 0">   
                    <div class="f16 c9 t">简答题</div>
                    <div class="flex" >                                 
                        <div class="item" v-for="(item,index) in list_jd" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div>      
                </div>
            </div>          
          </el-col>
          <el-col :span="18">             
            <div class="shadowBox minHeight">
              <div class="mainTop f18 c3" >{{pageData.info.exTitle}}</div>
                <div class="subItems"  v-for="(item,index) in questions" :key="index" :id="'choose'+(index+1)">
                    <div class="subl">
                      <div class="title single">
                          <span class="d">{{item.QT_Index}}.</span>
                          <span class="t" v-if="item.QT_Type=='1'">单选题</span>
                          <span class="t" v-if="item.QT_Type=='2'">多选题</span>
                          <span class="t" v-if="item.QT_Type=='3'">判断题</span>
                          <span class="t" v-if="item.QT_Type=='4'">填空题</span>
                          <span class="t" v-if="item.QT_Type=='5'">简答题</span>
                          <span class="d" v-html="item.QT_Content.replace(/<\/?[^>]*>/g,'')"></span>
                          <span class="s">({{item.Score}}分)</span>
                      </div>
                      <div class="items"  v-if="item.QT_Type=='1'">
                          <div  v-for="(_item,index) in item.items" :key="index">
                             <el-radio v-model="Letter[item.AN_Content]" disabled :label="Letter[_item.siIndex]"></el-radio>. {{_item.siContent}}
                          </div>                        
                      </div>
                      <div class="items"  v-if="item.QT_Type=='2'">                       
                          <div v-for="(_item,index) in item.items" :key="index" > 
                            <div v-if="item.AN_Content.indexOf(_item.siIndex)>=0">                          
                              <el-checkbox checked disabled :label="Letter[_item.siIndex]"></el-checkbox>. {{_item.siContent}}
                            </div>
                            <div v-else>                          
                              <el-checkbox  disabled :label="Letter[_item.siIndex]"></el-checkbox>. {{_item.siContent}}
                            </div>
                          </div>              
                      </div>
                      <div class="items"  v-if="item.QT_Type=='3'">
                          <div v-if="item.AN_Content=='1'">
                            <div><el-radio value="正确" disabled label="正确" ></el-radio></div>
                            <div ><el-radio value="" disabled label="错误"></el-radio></div>
                          </div>
                          <div v-else>
                            <div><el-radio value="" disabled label="正确" ></el-radio></div>
                            <div ><el-radio value="错误" disabled label="错误"></el-radio></div>
                          </div>
                                                  
                      </div>
                      <div class="res" v-if="item.QT_Type=='1'">                          
                          <span class="color_blue" v-if="item.AN_Content == item.QT_Answer">恭喜您，回答正确!</span>
                          <span class="color_red" v-else>对不起，回答错误!</span>
                          <span class="f14 c3">正确答案：{{Letter[item.QT_Answer]}}</span>
                      </div>
                       <div class="res" v-if="item.QT_Type=='2'">                          
                          <span class="color_blue" v-if="item.AN_Content == item.QT_Answer">恭喜您，回答正确!</span>
                          <span class="color_red" v-else>对不起，回答错误!</span>
                          <span class="f14 c3">正确答案：{{temp_arr(item.QT_Answer)}}</span>
                      </div>
                       <div class="res" v-if="item.QT_Type=='3'">                          
                          <span class="color_blue" v-if="item.AN_Content == item.QT_Answer">恭喜您，回答正确!</span>
                          <span class="color_red" v-else>对不起，回答错误!</span>
                          <span class="f14 c3">正确答案：{{item.AN_Content=='1'?'正确':'错误'}}</span>
                      </div>
                      <div class="res2"  v-if="item.QT_Type=='5'">
                          <div >{{item.AN_Content}}</div>
                      </div>
                       <div class="res2"  style="margin-top:24px" v-if="item.QT_Type=='5'">
                          <div >解析：{{item.w_remark }}</div>
                      </div>
                    </div>
                    <div class="subr">
                        <span v-if="item.AN_Content == item.QT_Answer" class="iconfont icon-a-37_dui" style="color:#4B9AFB;margin-right:20px"></span>
                        <span   v-else class="iconfont icon-a-36_cuo" style="color:#F7413F;margin-right:20px"></span>
                        得分：{{item.AN_Score}}分
                    </div>  
              </div>
             
            </div>           
          </el-col>
        </el-row>    
    </div> 
   </div>
   <div style="height:92px" v-if="showtype"></div>   
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { getExamInfo ,getExamCard} from '@/api/api'
import Nav from "../../components/Nav.vue";
  var Letter =["","A","B","C","D","E","F","G","H","I","J","K","L","M","N"]

export default {
 
  components: { Nav}, 
   data() {
      return {
        Letter:["","A","B","C","D","E","F","G","H","I","J","K","L","M","N"],
        showtype:false,
        tiId:this.$route.query.taskTI_ID,
        exId:this.$route.query.liId,
        pageData:null,
        percent_:'',
        hg:'',
        zdsc:'',
        list_dx:[],
        list_dd:[],
        list_pd:[],
        list_tk:[],
        list_jd:[],
        questions:[]
      };
    },
    created() {      
      this.getExamInfoFun()
    },

    methods: {     

      goAnchor(selector) {//参数selector是id选择器（#anchor14）
          document.querySelector(selector).scrollIntoView({
              behavior: "smooth"
          });
             
      },
      temp_arr(QT_Answer){
        var QT_Arr = QT_Answer.split('|') 
        var temp_arr = ''
        for(var i=0;i<QT_Arr.length;i++){
            var ii = QT_Arr[i]
            temp_arr+= Letter[ii]
        }
        return(temp_arr)        
      },
      tapSee(){
         this.showtype = true
         this.getExamCardFun()
      },
      getExamCardFun(){
         var that = this
         var data = {
            memberId :Cookies.get('qslmemberId'),
            tiId : that.tiId      
         } 
          getExamCard(data)
          .then(res => {            
            console.log(res.body.result)  
            let listItems = res.body.result
             listItems.forEach(function(item) {               
                if(item.QT_Type == '1')
                {                  
                  that.list_dx.push(item)
                }
                if(item.QT_Type == '2')
                {                  
                  that.list_dd.push(item)
                }
                 if(item.QT_Type == '3')
                {                  
                  that.list_pd.push(item)
                }
                 if(item.QT_Type == '4')
                {                  
                  that.list_tk.push(item)
                }
                 if(item.QT_Type == '5')
                {                  
                  that.list_jd.push(item)
                }                      
              })         
          })
          .catch(err => {})
        },
       ormateSeconds(endTime){
        let secondTime = parseInt(endTime)//将传入的秒的值转化为Number
        let min = 0// 初始化分
        let h =0// 初始化小时
        let result=''
        if(secondTime>60){//如果秒数大于60，将秒数转换成整数
            min=parseInt(secondTime/60)//获取分钟，除以60取整数，得到整数分钟
            secondTime=parseInt(secondTime%60)//获取秒数，秒数取佘，得到整数秒数
            if(min>60){//如果分钟大于60，将分钟转换成小时
                h=parseInt(min/60)//获取小时，获取分钟除以60，得到整数小时
                min=parseInt(min%60) //获取小时后取佘的分，获取分钟除以60取佘的分
            }
        }       
        if(h==0){
            result=`${min}分${secondTime}秒`
        }
        if(min==0){
            result=`${secondTime}秒`
        }else{
            result=`${h}时${min}分${secondTime}秒`
        }
        return result
    },
      getExamInfoFun(){
         var that = this
         var data = {
            memberId :Cookies.get('qslmemberId'),
            tiId : that.tiId,
            exId:   that.exId  
         } 
          getExamInfo(data)
          .then(res => {            
            console.log(res.body.result)  
            that.pageData = res.body.result
            var data = res
            if(data.body.result.examStatus=='2'){
                if(data.body.result.examanswer.AN_IsFinished=='2'){ 
                        this.$alert('当前考试任务待判卷中请耐心等待！!', '提示信息', {
                          showClose: false,
                          confirmButtonText: '确定',    
                        })
                          .then(() => {
                            this.$router.go(-1);
                        })                              
                } else{
                    var d1 = data.body.result.examanswer.AN_FinishTime;
                    var d2 = data.body.result.examanswer.AN_CreateOn;
                    var hg = data.body.result.info.exTotalscore*data.body.result.info.exPassingScore/100
                    var totalstime = (data.body.result.info.exExamTime*60)
                    var readytime = (d1 - d2)/1000
                    if(totalstime<readytime){
                        var zdsc =data.body.result.info.exExamTime+'分种'
                    }else{
                        var zdsc = that.ormateSeconds((d1 - d2)/1000)
                    }
                    var dd = data.body.result.examanswer.rightNum//答对
                    var df = data.body.result.examanswer.AN_Score//德分
                    var zf = data.body.result.info.exTotalscore//总分
                    var total = data.body.result.questions.length
                    var percent_ = (dd/total)*100
                    that.percent_ = Math.floor(percent_)+'%'
                    that.hg = hg
                    that.zdsc = zdsc                  
                }
                that.questions = data.body.result.questions
            }           
          })
          .catch(err => {});
      }    
    }
    
    //   destroyed(){
    //           this.$alert('当前考试任务待判卷中请耐心等待！!', '提示信息', {
    //                       showClose: false,
    //                       confirmButtonText: '确定',    
    //                     })
    //                       .then(() => {
    //                         this.$router.go(-1);
    //                     })   
    // }
    
  };
</script>
<style scoped>
.subItems{
  padding:24px;
  font-size:14px;
  display:flex
}
.subItems .subl{
  width:670px;
  margin-right:60px
}
.subItems .items{
  color:#ccc;
  line-height:22px;
}
.subItems .items div{
  margin:10px 0
}
.color_red{
  color:#F7413F
}
.color_blue{
  color:#4B9AFB
}
.subItems .res{
  width: 668px;
  height: 46px;
  line-height:46px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-top:20px
}
.subItems .res2{
  padding:24px;
  background: #f0f0f0;
  line-height:22px;
  color:#ccc
}

.subItems .res span{
  padding:0 20px
}
 p{
  display:inline
}
.subItems .subr{
  flex:1;
  font-size:14px;
  color:#333;
  font-weight:bold
}
.subItems .title{
  margin-bottom:14px;
  line-height:24px
}
.subItems .d{
  font-size:14px;
  color:#333;
  font-weight:bold;
}
.subItems .s{
  color:#999;
  font-size:14px;
  margin-left:50px
}
.subItems .t{
  width: 44px;
  height: 19px;
  background: rgba(255,255,255,0.00);
  border: 1px solid #4b9afb;
  border-radius: 2px;
  font-size:12px;
  color:#4B9AFB;
  line-height:21px;
  padding:2px 3px
}
.cardItem{
  padding:24px
}
.cardItem .t{
  margin:3px 0 15px 0;
}
.cardItem .item{
  width: 40px;
  height: 40px;
  color:#F7413F;
  border:1px solid #F7413F;
  background: #fee3e2;
  border-radius: 4px;
  margin-right: 15px;
  margin-bottom:15px;
  font-size:14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.cardItem .select{
  color:#4B9AFB;
  border:1px solid #4B9AFB;
  background: #e4f0fe;
}
.cardItem .flex{ 
  flex-direction: row;
  flex-wrap: wrap;
}
.cardItem .st span{
  position: relative;
  flex:1;
  padding-left:20px;
  padding-bottom:15px
}
.cardItem .st span::before{
  content: '';
  position:absolute;
  left:0px;
  top:6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.cardItem .st .s1::before{ 
  background: #F7413F;
}
.cardItem .st .s2::before{ 
  background: #4B9AFB;
}
.cardFotter{
  height: 72px;
  background: #ffffff;
  width:100%;
  position: fixed;
  bottom:0;
  left:0;right: 0;
}

.ksjg{
  background:#F0F0F0;
  margin:24px;
  padding:40px
}
.ksjg .flex{
  margin-bottom:40px ;  
}
.ksjg .flex div{
  flex:1
}
.ckjg{
  text-align:center;
  padding:16px 0 40px 0
}

.el-button{
  font-size:18px;
  padding:14px 20px
}
</style>


// WEBPACK FOOTER //
// src/views/Exam/result.vue